/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Verifying_AccessInputs */

const en_layout_verifying_access = /** @type {(inputs: Layout_Verifying_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying access...`)
};

const es_layout_verifying_access = /** @type {(inputs: Layout_Verifying_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando acceso...`)
};

/**
* | output |
* | --- |
* | "Verifying access..." |
*
* @param {Layout_Verifying_AccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const layout_verifying_access = /** @type {((inputs?: Layout_Verifying_AccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Verifying_AccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_layout_verifying_access(inputs)
	return es_layout_verifying_access(inputs)
});